import { useMutation } from "@/compat/reactQuery";
import riskAssessmentHistoryService from "../../services/riskAssessmentHistoryService";

const useShareRiskAssessmentHistory = () =>
  useMutation(riskAssessmentHistoryService.shareRiskAssessmentHistory);

export default useShareRiskAssessmentHistory;